// Account persistence for the cross-app theme (injected into @eb/auth-ui's
// ThemeProvider). Reads/writes public.user_settings.theme_preference directly
// under RLS with the cookie session. Returns null when signed out.
import type { ThemeDeps, ThemeMode } from '@eb/auth-ui';
import { supabase } from '~/lib/supabase-browser';

function valid(v: unknown): ThemeMode | null {
  return v === 'system' || v === 'light' || v === 'dark' ? v : null;
}

export const themeDeps: ThemeDeps = {
  async loadAccountTheme() {
    const { data: sessionData } = await supabase.auth.getSession();
    const uid = sessionData.session?.user?.id;
    if (!uid) return null;
    const { data } = await supabase
      .from('user_settings')
      .select('theme_preference')
      .eq('user_id', uid)
      .maybeSingle();
    return valid(data?.theme_preference);
  },
  async saveAccountTheme(mode) {
    const { data: sessionData } = await supabase.auth.getSession();
    const uid = sessionData.session?.user?.id;
    if (!uid) throw new Error('Sign in to save the theme to your account');
    const { error } = await supabase
      .from('user_settings')
      .upsert(
        { user_id: uid, theme_preference: mode, updated_at: new Date().toISOString() },
        { onConflict: 'user_id' }
      );
    if (error) throw error;
  },
};
